import { addLeadingZero } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next";
import i18next from "i18next";
import ExifReader from "exifreader";
import { baseUrl } from "../../../config";

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      details: [
        {
          title: i18n.t("files.basic_details"),
          values: [],
          funcName: "setBasicDetails",
        },
        {
          title: i18n.t("files.image_details"),
          values: [],
          blacklistValues: [
            "PixelYDimension",
            "PixelXDimension",
            "resolutionunit",
          ],
          extensions: [".png", ".jpg"],
          funcName: "getImageDetails",
        },
      ],
    };
  },
  created() {
    this.setDetails();
  },
  methods: {
    setDetails() {
      this.details = this.details.filter((section, index) => {
        if (section.extensions) {
          if (section.extensions.includes(this.file.extension)) {
            //get details
            this[section.funcName](index);
            return true;
          }
        } else {
          //alway get these
          this[section.funcName](index);
          return true;
        }

        return false;
      });
    },
    getImageDetails(index) {
      ExifReader.load(this.createDownloadLink()).then((r) => {
        this.details[index].values = Object.keys(r)
          .sort()
          .map((key) => {
            const transKey = `file_details.${key.toLowerCase()}`;

            return {
              key,
              name: !i18n.t(transKey).includes("file_details.")
                ? i18n.t(transKey)
                : key,
              value: r[key].description,
            };
          })
          .filter(
            (item) =>
              item.value &&
              item.value !== " " &&
              !this.details[index].blacklistValues.includes(item.key)
          );
      });
    },
    createDownloadLink() {
      // const items = getFoldersAndFiles(data);
      let downloadLink = `${baseUrl}/download?`;

      downloadLink += `file=${this.file.id}`;

      downloadLink += `&company=${this.$store.state.company}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
    getVideoDetails(index) {},
    setBasicDetails(index) {
      if (this.file) {
        this.details[index].values = [];
        const keys = ["created_at", "size", "pages", "dimensions"];

        keys.forEach((key) => {
          if (this.file[key]) {
            this.details[index].values.push({
              name: i18n.t(`file_details.${key}`),
              value: key === "created_at" ? this.dateAdded() : this.file[key],
            });
          }
        });
      }
    },
    dateAdded() {
      if (this.file) {
        const date = new Date(this.file.created_at);

        return `${addLeadingZero(date.getDate())}/${addLeadingZero(
          date.getMonth() + 1
        )}/${date.getFullYear()}`;
      }

      return false;
    },
  },
};
